<template>
  <!-- This route exists solely to open the install modal. -->
  <div />
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onBeforeUnmount,
  onMounted,
  ref,
} from "vue";
import { useModal } from "vue-final-modal";
import { useRoute, useRouter } from "vue-router";

import * as inject from "@/components/inject";
import ImportModal from "@/components/marketplace/ImportModal.vue";
import { redirectToSafety } from "@/utils/navigation/menu";

export default defineComponent({
  name: "InstallRoute",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const menu = inject.menu();
    const profile = inject.profile();
    const didNavigateAway = ref(false);

    const extensionId = computed(() => {
      const q = route.query;
      const id = (typeof q.id === "string" && q.id) || undefined;
      return id;
    });

    const navigateAway = async () => {
      if (didNavigateAway.value) return;
      didNavigateAway.value = true;

      await redirectToSafety(router, profile, menu);
    };

    const { open: openSelect, close: closeSelect } = useModal({
      component: ImportModal,
      attrs: {
        extensionId: extensionId.value,
        afterCancelled: () => {
          void navigateAway();
        },
      },
    });

    onMounted(() => {
      openSelect();
    });

    onBeforeUnmount(() => {
      // Ensure the modal isn't left around if the route changes for other reasons.
      closeSelect();
    });

    return {};
  },
});
</script>
